import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import { setLocalUser, getToken, getStoredUser } from '../../../Config/ApiConfig';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(getStoredUser() || {});
  const [token, setToken] = useState(getToken() || '');

  const handleChangeUser = useCallback((userOrFn) => {
    if (typeof userOrFn === 'function') {
      setUser(prevUser => {
        const newUser = userOrFn(prevUser);
        const safeUser = newUser ?? {};
        setLocalUser(safeUser);
        return safeUser;
      });
    } else {
      const safeUser = userOrFn ?? {};
      setLocalUser(safeUser);
      setUser(safeUser);
    }
  }, []);

  const handleTokenChange = useCallback((newToken) => {
    setToken(newToken);
  }, []);

  // Sync user/token when login/logout/token refresh happens
  useEffect(() => {
    const handler = () => {
      const currentToken = getToken() || '';
      if (currentToken !== token) {
        setToken(currentToken);
      }
      const currentUser = getStoredUser() || {};
      setUser(currentUser);
    };
    window.addEventListener('user-data-change', handler);
    return () => window.removeEventListener('user-data-change', handler);
  }, [token]);

  return (
    <GlobalContext.Provider value={{ 
      loading, 
      setLoading, 
      user, 
      changeUser: handleChangeUser,
      token,
      setToken: handleTokenChange
    }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);